import ExternalScriptLoader from './external-script-loader'

class Iframely extends ExternalScriptLoader {
  scriptUrl = 'https://cdn.iframe.ly/embed.js?iframe=true&omit_script=true'
  readyStates = ['complete', 'interactive']

  async load() {
    await this.loadScript()
    window.iframely.load()
  }
}

export default new Iframely()
